<template>
  <div class="home ld-background ld-right-slide ld-scroll-none">
    <div v-if="screenWidthSmall" class="ld-logo-right-slide" :class="{'pr-4' : screenWidthSmall}">
      <!-- Logo -->
      <img class="ld-width-100" :src="getComponentImagePath('lollicup_logo_transparency_400_201.png')"/>
    </div>
    <nav-slide-component
      @imageMounted="imageMountedLollicupFoodDrinks"
      :setClassContainer="'ld-right-slide ld-scroll-none'"
      :setClassImage="'ld-right-slide-image'"
      :setIdImage="imageIdDrinks"
      :setSourceImage="getComponentImagePath('lollicup_food_drinks_1799_1200.jpg')"
      :setStyleContainer="''"
      :setStyleImage="setImageStyleDrinks"
    ></nav-slide-component>
  </div>
</template>

<script>
  import * as Utils from '../js/utils';
  import GeneralMixin from '../mixins/general_mixin';
  import NavSlideComponent from './nav_slide_component.vue';

  export default {

    components: {
      NavSlideComponent
    },

    methods: {
      /**
       * imageMountedLollicupFoodDrinks will listen for the image mounted event from the nav slide component, then get
       * and set the image style left offset for the Lollicup food drinks image. This functionality was created because
       * the width of the image may not be available on any of the built in Vue instance functions, due to loading
       * delays.
       */
      imageMountedLollicupFoodDrinks: function() {
        this.setImageStyleDrinks.left = Utils.getImageStyleLeft(document, false, this.imageIdDrinks,
          this.screenWidthSmall, this.windowWidth);
      }
    },

    mixins: [GeneralMixin],

    name: 'homeComponent',

    props: ['screenWidthSmall', 'windowHeight', 'windowWidth'],

    watch: {
      windowWidth: function(windowWidth) {
        this.setImageStyleDrinks.left = Utils.getImageStyleLeft(document, false, this.imageIdDrinks,
          this.screenWidthSmall, windowWidth);
      }
    },

    data() {
      return {
        imageIdDrinks: 'lollicupFoodDrinks2310x1200',
        setImageStyleDrinks: {
          left: 0
        }
      };
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/home_component.vue